import $ from 'jquery';

export default class Input {
  constructor() {
    this.init();
  }

  // eslint-disable-next-line class-methods-use-this
  init() {
    // custom select
    const selectCustom = '.js-input-filter';
    const selectCustomDropdown = '.js-input-filter-dropdown';
    const closeCustomDropdown = 'js-input-filter-dropdown-close';
    // const clearSelectCustom = '.js-clear-input-filter';
    const inputFlatpickr = '.js-flatpickr';
    const inputFlatpickrRangeClass = 'js-flatpickr-range';
    const samosetProperty = 'Samoset Resort';
    const sagamoreProperty = 'The Sagamore Resort';
    const lakePlacidLodgeProperty = 'Lake Placid Lodge';
    const propertySelectTrigger = $('.select-filter_property');
    const adultsLabel = $('.counter-name--adults');
    const childrenLabel = $('.counter-name--children');
    let propertyName = propertySelectTrigger.text();

    function initChoiceCheckFilter() {
      $(selectCustomDropdown).each(function () {
        if ($(this).length === 1 && $(this).find('input:checked').length >= 1) {
          const arChecked = [];
          $(this).siblings(selectCustom).addClass('select-filter_input--selected');
          $(this).find('input:checked').each(function () {
            arChecked.push($(this).siblings().attr('aria-label'));
          });

          $(this).siblings(`${selectCustom}:not(:empty)`).text(() => {
            if (arChecked.length === 1) {
              return arChecked;
            }
            return `${arChecked[0]} +${arChecked.length - 1}`;
          });
        }
      });
    }
    function clearAges() {
      const childrenSelectParent = document.querySelector('#childAgesFields');
      const childrenSelect = childrenSelectParent.querySelectorAll('select');
      childrenSelect.forEach((el) => {
        const selOptions = el.querySelectorAll('option');
        for (let i = 0; i < selOptions.length; i++) {
          selOptions[i].style.display = 'block';
        }
      });
      adultsLabel.html('Adults <span>Ages 18 & up</span>');
      childrenLabel.html('Children <span>Ages 17 & under stay free</span>');
    }
    function hideAgesOption() {
      const childrenSelectParent = document.querySelector('#childAgesFields');
      const childrenSelect = childrenSelectParent.querySelectorAll('select');
      childrenSelect.forEach((el) => {
        const selOptions = el.querySelectorAll('option');
        for (let i = 0; i < selOptions.length; i++) {
          selOptions[i].setAttribute('data-index', i);
          if (selOptions[i].getAttribute('data-index') >= 13) {
            selOptions[i].style.display = 'none';
          }
        }
        if (parseInt(el.value, 10) >= 13) {
          // eslint-disable-next-line no-param-reassign
          el.value = '<1';
        }
      });
      adultsLabel.html('Adults <span>Ages 13 & up</span>');
      childrenLabel.html('Children <span>Ages 12 & under stay free</span>');
    }

    initChoiceCheckFilter();

    if ($('body').hasClass('samoset-site') || $('body').hasClass('lake-placid-lodge-site') || $('body').hasClass('sagamore-site')) {
      $('body').addClass('property-changed-age');
    }
    $(document).on('click', `${selectCustomDropdown} .js-counter-btn`, function () {
      const counterArr = [];
      const counterInput = $(this).parents(selectCustomDropdown).find('.js-counter-input');

      counterInput.each(function () {
        counterArr.push(`${$(this).val()} ${$(this).data('name-count')}`);
      });
      $(this).parents(selectCustomDropdown).siblings(selectCustom).text(counterArr.join(', '));
    });

    $(document).on('click keypress', `${selectCustomDropdown} ul li`, function (e) {
      const block = $(this).parents(selectCustomDropdown);
      const select = block.siblings(`${selectCustom}:not(:empty)`);
      const $input = $(select.data('input'));
      const delay = 100;
      select.text(e.target.innerText);
      $input.val($(this).data('value'));
      propertyName = e.target.innerText;

      // eslint-disable-next-line max-len
      if (propertyName === samosetProperty || propertyName === sagamoreProperty || propertyName === lakePlacidLodgeProperty) {
        $('body').addClass('property-changed-age');
        hideAgesOption();
      } else {
        $('body').removeClass('property-changed-age');
        clearAges();
      }

      // close
      block.fadeOut(delay, function () {
        $(this).removeAttr('style').siblings().removeClass('opened');
        select.attr('aria-expanded', 'false');
      });

      setTimeout(() => {
        $input.trigger('change');
      }, delay);
    });

    $(document).on('focus', selectCustom, function () {
      $('.opened').not($(this)).removeClass('opened').siblings(selectCustomDropdown)
        .fadeOut(100);
    });

    $(document).on('focus', 'input', function () {
      $('.opened').not($(this).closest(selectCustomDropdown).siblings('.opened')).removeClass('opened').siblings(selectCustomDropdown)
        .fadeOut(100);
    });

    $(document).on('focus', 'button:not(.js-counter-btn)', function () {
      $('.opened').not($(this)).removeClass('opened').siblings(selectCustomDropdown)
        .fadeOut(100);
    });

    $(document).on('click', selectCustom, function () {
      $(selectCustom).not($(this)).removeClass('opened').siblings(selectCustomDropdown)
        .fadeOut(100);
      const dropdown = $(this).siblings(selectCustomDropdown);
      $(this).toggleClass('opened');
      // eslint-disable-next-line no-unused-expressions
      $(this).hasClass('opened') ? dropdown.fadeIn(100) : dropdown.fadeOut(100);
      $(this).attr('aria-expanded', $(this).hasClass('opened') ? 'true' : 'false');
    });

    // keyboard up down list
    $(`${selectCustomDropdown}[role="list"]`).on('keydown', (e) => {
      const keyCode = (e.keyCode ? e.keyCode : e.which);
      if (keyCode === 13) { // enter
        e.target.click();
      }
      if (keyCode === 38) { // up
        e.preventDefault();
        const currentElement = $(document.activeElement).index();

        if (currentElement > 0) {
          $(document.activeElement).parent().children().eq(currentElement - 1)
            .focus();
        }
      }
      if (keyCode === 40) { // down
        e.preventDefault();
        const currentElement = $(document.activeElement).index();
        const { length } = $(document.activeElement).parent().children();

        if (currentElement < length - 1) {
          $(document.activeElement).parent().children().eq(currentElement + 1)
            .focus();
        }
      }
    });
    // keyboard up down list

    $(document).on('keydown', (event) => {
      const keycode = (event.keyCode ? event.keyCode : event.which);
      if (keycode === 27) {
        $(selectCustomDropdown).fadeOut(100, function () {
          $(this).removeAttr('style').siblings().removeClass('opened');
          $(selectCustom).attr('aria-expanded', 'false');
        });
      }
    });

    $(document).on('mousedown', (e) => {
      const divs = $(selectCustomDropdown);
      divs.each(function () {
        // eslint-disable-next-line max-len
        if ((!$(this).is(e.target) && $(this).has(e.target).length === 0) || $(e.target).hasClass(closeCustomDropdown)) {
          $(this).fadeOut(100, function () {
            $(this).removeAttr('style').siblings().removeClass('opened');
            $(selectCustom).attr('aria-expanded', 'false');
          });
        }
      });
    });

    function checkCounter($input) {
      let minV = parseInt($input.data('min-count'), 10);
      if (Number.isNaN(minV)) minV = 0;
      let maxV = parseInt($input.data('max-count'), 10);
      if (Number.isNaN(maxV)) maxV = 20;
      let v = parseInt($input.val(), 10);
      if (Number.isNaN(v)) v = minV; else if (v < minV) v = minV; else if (v > maxV) v = maxV;
      $input.val(v);

      if (v === minV) {
        $input.siblings('.js-counter-dec').addClass('disabled');
      } else {
        $input.siblings('.js-counter-dec').removeClass('disabled');
      }

      if (v === maxV) {
        $input.siblings('.js-counter-inc').addClass('disabled');
      } else {
        $input.siblings('.js-counter-inc').removeClass('disabled');
      }
    }

    function setupGuestsCombo() {
      if ($('#guestsTD').length === 0) return;

      const adults = $('#adults').val();
      const children = parseInt($('#children').val(), 10);

      const guestsText = `${adults} adult${adults < 2 ? '' : 's'}${children === 0 ? '' : `, ${children} child${children === 1 ? '' : 'ren'}`}`;
      const guestsElement = $('#guestsTD .js-input-filter');

      guestsElement.html(guestsText);
      guestsElement.attr('aria-label', `Show  Guests: ${guestsText}`);

      if (children === 0) {
        $('#childAges').hide();
      } else {
        $('#childAges').show();
        $('#childAgesFields > div').hide();
        const prevAges = $('#childAgesFields').data('ages').split(',');
        for (let i = 1; i <= children; i++) {
          const l = `childAge${i}`; const
            o = [];
          for (let j = 0; j < 18; j++) {
            o.push(`<option ${prevAges[i - 1] == j ? 'selected' : ''} >${j}</option>`);
          }
          if ($(`#b${l}`).length === 1) {
            $(`#b${l}`).show();
          } else {
            $('#childAgesFields').append(`<div id="b${l}"><div class="field-form"><label class="field-form_tl" for="${l}"></label><select name="${l}" id="${l}">${o.join('')}</select></div></div>`);
            $('#childAgesFields').find(`select[id=${l}]`).find('option').first()
              .text('<1');
            if ($('body').hasClass('property-changed-age')) {
              hideAgesOption();
            }
          }
        }
      }
    }

    // counter input
    // to initialize on load
    $('#guestsTD .js-counter-input').each(function () {
      checkCounter($(this));
    });
    setupGuestsCombo();

    $(document).on('click', '#guestsTD .js-counter-input-b .js-counter-btn', function () {
      const $input = $(this).siblings('.js-counter-input');
      let value = parseInt($input.val(), 10);
      const minV = parseInt($input.data('min-count'), 10);
      if (Number.isNaN(value)) value = minV;

      if ($(this).hasClass('js-counter-dec')) {
        value -= 1;
      } else {
        value += 1;
      }
      $input.val(value);
      checkCounter($input);
      setupGuestsCombo();
    });

    $(document).on('change keyup input click', '#guestsTD .js-counter-input', function () {
      checkCounter($(this));
      setupGuestsCombo();
    });

    $(document).on('click', '.js-guests-clear', () => {
      const guestCounter = $('.js-counter-input');
      guestCounter.val(0);
      setupGuestsCombo();
    });
    // counter input

    function initFlatpickr() {
      const elements = document.querySelectorAll(inputFlatpickr);

      if (elements.length) {
        import('flatpickr').then((module) => {
          const flatpickr = module.default;

          const defaultConfig = {
            minDate: 'today',
            static: true,
            position: 'auto center',
            dateFormat: 'm/d/Y',
            onReady() {
              // Enable keyboard navigation for flatpickr
              const calendar = this.calendarContainer;
              const days = calendar.querySelectorAll('.flatpickr-day:not(.flatpickr-disabled)');
              const daysContainer = calendar.querySelector('.flatpickr-days');

              // Helper function to build navigation elements array (exclude days)
              const buildNavigationElements = () => {
                const navigationOrder = [
                  '.flatpickr-prev-month',
                  '.flatpickr-monthDropdown-months',
                  '.cur-year',
                  '.flatpickr-next-month',
                ];

                const allElements = [];

                // Add only navigation elements, days handle Tab separately
                navigationOrder.forEach((selector) => {
                  const navElements = calendar.querySelectorAll(selector);
                  navElements.forEach((el) => allElements.push(el));
                });

                return allElements;
              };

              // Helper function to handle tab navigation
              const handleTabNavigation = (e, currentElement) => {
                e.preventDefault();

                const allElements = buildNavigationElements();
                const currentIndex = allElements.indexOf(currentElement);

                // Check if current element is the "next month" button
                const isNextMonthButton = currentElement.classList.contains('flatpickr-next-month');

                if (!e.shiftKey && isNextMonthButton) {
                  // If Tab and it's the "next month" button, focus the first available day
                  const firstDay = calendar.querySelector('.flatpickr-day:not(.flatpickr-disabled)');
                  if (firstDay) {
                    firstDay.focus();
                  }
                  return;
                }

                if (e.shiftKey) {
                  // Shift+Tab - go to previous navigation element
                  if (currentIndex > 0 && !allElements[currentIndex - 1].classList.contains('flatpickr-disabled')) {
                    allElements[currentIndex - 1].focus();
                  } else {
                    // If first element, return focus to input
                    this.input.focus();
                  }
                } else if (currentIndex < allElements.length - 1) {
                  allElements[currentIndex + 1].focus();
                } else {
                  // If last element, return focus to input
                  this.input.focus();
                }
              };

              // Remove tabindex="-1" from days container
              if (daysContainer) {
                daysContainer.removeAttribute('tabindex');
              }

              // Make calendar days focusable (Tab handled separately)
              days.forEach((day) => {
                day.setAttribute('tabindex', '0');
              });

              // Make month dropdown focusable
              const monthDropdown = calendar.querySelector('.flatpickr-monthDropdown-months, .flatpickr-current-month .flatpickr-monthDropdown-months, select.flatpickr-monthDropdown-months');
              if (monthDropdown) {
                monthDropdown.setAttribute('tabindex', '0');
                monthDropdown.removeAttribute('disabled');
              }

              // Make year input focusable
              const yearInput = calendar.querySelector('.numInput.cur-year, .flatpickr-current-month .cur-year, input.cur-year');
              if (yearInput) {
                yearInput.setAttribute('tabindex', '0');
                yearInput.removeAttribute('disabled');
              }

              // Make navigation buttons focusable
              const prevButton = calendar.querySelector('.flatpickr-prev-month, .flatpickr-months .flatpickr-prev-month, button.flatpickr-prev-month');
              const nextButton = calendar.querySelector('.flatpickr-next-month, .flatpickr-months .flatpickr-next-month, button.flatpickr-next-month');
              if (prevButton) {
                prevButton.setAttribute('tabindex', '0');
                prevButton.removeAttribute('disabled');
              }
              if (nextButton) {
                nextButton.setAttribute('tabindex', '0');
                nextButton.removeAttribute('disabled');
              }

              // Also make all focusable elements in calendar accessible
              const allFocusableElements = calendar.querySelectorAll('button, select, input, [tabindex]');
              allFocusableElements.forEach((el) => {
                if (el !== daysContainer) { // Don't modify the days container
                  el.setAttribute('tabindex', '0');
                  el.removeAttribute('disabled');
                }
              });

              // Add keyboard event listener for all calendar elements
              calendar.addEventListener('keydown', (e) => {
                const { target } = e;
                const isNavigationButton = target.classList.contains('flatpickr-prev-month') || target.classList.contains('flatpickr-next-month');
                const isMonthDropdown = target.classList.contains('flatpickr-monthDropdown-months') || target.tagName === 'SELECT';
                const isDay = target.classList.contains('flatpickr-day') && !target.classList.contains('flatpickr-disabled');

                // Handle Tab navigation for navigation elements only (days handle Tab separately)
                if (e.key === 'Tab' && !isDay) {
                  handleTabNavigation(e, target);
                  return;
                }

                // Handle specific elements
                if (isNavigationButton) {
                  switch (e.key) {
                    case 'Enter':
                    case ' ':
                    case 'Space':
                      e.preventDefault();
                      target.click();
                      break;
                    default:
                      break;
                  }
                } else if (isMonthDropdown) {
                  switch (e.key) {
                    case 'Enter':
                    case ' ':
                    case 'Space':
                      e.preventDefault();
                      target.focus();
                      break;
                    default:
                      break;
                  }
                } else if (isDay) {
                  // Handle day navigation and Tab logic
                  const daysArr = Array.from(calendar.querySelectorAll('.flatpickr-day:not(.flatpickr-disabled)'));
                  const idx = daysArr.indexOf(target);
                  const daysInRow = 7;

                  switch (e.key) {
                    case 'ArrowLeft':
                      e.preventDefault();
                      if (idx > 0) daysArr[idx - 1].focus();
                      break;
                    case 'ArrowRight':
                      e.preventDefault();
                      if (idx < daysArr.length - 1) daysArr[idx + 1].focus();
                      break;
                    case 'ArrowUp':
                      e.preventDefault();
                      if (idx - daysInRow >= 0) daysArr[idx - daysInRow].focus();
                      break;
                    case 'ArrowDown':
                      e.preventDefault();
                      if (idx + daysInRow < daysArr.length) daysArr[idx + daysInRow].focus();
                      break;
                    case 'Space':
                    case ' ':
                    case 'Enter':
                      e.preventDefault();
                      target.click();
                      break;
                    case 'Tab':
                      e.preventDefault();
                      if (e.shiftKey) {
                        const nextMonthButton = calendar.querySelector('.flatpickr-next-month');
                        nextMonthButton.focus();
                      } else {
                        this.input.focus();
                      }
                      break;
                    default:
                      break;
                  }
                }
              });
            },
            onOpen() {
              // Focus first available day when calendar opens
              setTimeout(() => {
                const calendar = this.calendarContainer;
                const days = calendar.querySelectorAll('.flatpickr-day:not(.flatpickr-disabled)');
                if (days.length > 0) {
                  days[0].focus();
                }
              }, 100);
            },
          };

          elements.forEach((el) => {
            const config = { ...defaultConfig };

            if (el.classList.contains(inputFlatpickrRangeClass)) {
              config.mode = 'range';
            }

            flatpickr(el, config);
          });
        });
      }
    }
    initFlatpickr();
  }
}
